// Copyright (c) Move Closer 2023.

import { Locale } from 'vue-i18n'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface ILocaleContentManager {
  add<P extends string | number, T>(property: P, value: T, locale?: Locale): P
  retrieve<P>(property: string | number, locale?: Locale): P
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const LocaleContentManagerType = Symbol.for('ILocaleContentManager')

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export type LocaleContentRule = Record<Locale, Record<any, any>>
